// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pt-datepicker-style {\n    height: 40px;\n    background-color: #ffffff;\n    border: 0 solid;\n    border-bottom: 1px solid #BFC0C2;\n    font-size: 16px;\n    text-align: left;\n    padding: 0 16px;\n    width: 100%;\n}", ""]);
// Exports
module.exports = exports;
